import { route } from 'frontend/inertia/routes'

export const groupsPath = {
  // mirrors frontend_academy_partner_groups
  index: route('/academy_partner/groups'),
  // mirrors new_frontend_academy_partner_group
  new: route('/academy_partner/groups/new'),
  // mirrors frontend_academy_partner_group
  show: route('/academy_partner/groups/:id'),
  // mirrors edit_frontend_academy_partner_group
  edit: route('/academy_partner/groups/:id/edit'),
}
